import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitRepos } from '@/services/git/api';
import type { GitRepoWithSelection } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitRepos(options?: { enabled?: boolean }): UseQueryResult<GitRepoWithSelection[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);
  const { enabled = true } = options ?? {};

  return useQuery({
    queryKey: ['gitRepos', orgId],
    queryFn: () => fetchGitRepos(orgId!),
    enabled: enabled && !!token && !!orgId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
